import { API_BASE, parseCourse } from '../legacy/api.js'

/**
 * Osekaná ukázka JEN klikacích otázek (hotspotů) — pro ruční otestování.
 *
 * Čtyři otázky jsou beze změny okopírované z produkčních dat (modul1
 * a modul3), stejnou cestou jako ostrý kurz — přes `parseCourse`. Žádná
 * z odpovědí, obrázků ani souřadnic není vymyšlená.
 *
 * Nemá to nic společného s `routes.ts` (zamrzlý kontrakt) ani s reálným
 * API — jde jen o vývojářskou pomůcku. Otevře se na `/test-hotspoty`.
 */

/**
 * Původ datového serveru s obrázky kurzů — odvozený z `API_BASE`.
 * Ostrý build → `https://www.safetutor.cz`, staging build → `https://www.safetutor.org`
 * (staging zrcadlo), aby ani tahle vývojářská ukázka neodkazovala do ostrého
 * provozu. `i.imgur.com` je cizí hosting (jako YouTube/Vimeo) a nechává se být.
 */
const DATA = new URL(API_BASE).origin
const d = (path: string): string => `${DATA}/data/${path}`

const RAW_COURSE = {
  controls: true,
  pointsToPassPercent: 60,
  objects: {
    object1: {
      index: 1,
      type: 'highlight',
      videoUrl: '',
      imageUrl: 'https://i.imgur.com/ZUgYR4H.jpg',
      videoEndCorrectUrl: '',
      videoEndWrongUrl: '',
      question:
        '1. Všimli jste si, jaké bezprostřední a neviditelné nebezpečí ženě hrozí? ' +
        'Označte myší místo, kde se nebezpečí skrývá.',
      answers: {},
      correctAnswer: '',
      images: {
        '1': {
          baseImageUrl: 'https://i.imgur.com/yV2Whao.png',
          hihglightImagerUrl: 'https://i.imgur.com/7cbojF8.png',
          width: 140,
          height: 734,
          scale: 0.5,
          posFromTopinPercent: 31.944,
          posFromLeftinPercent: 46.6146,
        },
      },
      correctImage: 1,
      uiLayout: 'top',
      time: 30,
      timeWarning: 10,
      pointsMax: 10,
      pointsSecondAttempt: 5,
      pointsTimePenalty: 3,
    },
    object2: {
      index: 2,
      type: 'highlight',
      videoUrl: '',
      imageUrl: d('data_zakl_skoleni_modul1/0-uvod/1_0_5_1_S.jpg'),
      videoEndCorrectUrl: '',
      videoEndWrongUrl: '',
      question: '2. Klikněte na krabici, kterou krátkodobě mohou zvedat muži.',
      answers: {},
      correctAnswer: '',
      images: {
        '1': {
          baseImageUrl: d('data_zakl_skoleni_modul1/0-uvod/1_0_5_1_S_30kg.png'),
          hihglightImagerUrl: d('data_zakl_skoleni_modul1/0-uvod/1_0_5_1_S_30kg_high.png'),
          width: 218,
          height: 224,
          scale: 0.53,
          posFromTopinPercent: 73.52,
          posFromLeftinPercent: 49.375,
        },
        '2': {
          baseImageUrl: d('data_zakl_skoleni_modul1/0-uvod/1_0_5_1_S_40kg.png'),
          hihglightImagerUrl: d('data_zakl_skoleni_modul1/0-uvod/1_0_5_1_S_40kg_high.png'),
          width: 247,
          height: 212,
          scale: 0.53,
          posFromTopinPercent: 76.11,
          posFromLeftinPercent: 62.03,
        },
        '3': {
          baseImageUrl: d('data_zakl_skoleni_modul1/0-uvod/1_0_5_1_S_50kg.png'),
          hihglightImagerUrl: d('data_zakl_skoleni_modul1/0-uvod/1_0_5_1_S_50kg_high.png'),
          width: 272,
          height: 257,
          scale: 0.53,
          posFromTopinPercent: 72.22,
          posFromLeftinPercent: 75.156,
        },
      },
      correctImage: 3,
      uiLayout: 'top',
      time: 30,
      timeWarning: 10,
      pointsMax: 10,
      pointsSecondAttempt: 5,
      pointsTimePenalty: 3,
    },
    object3: {
      index: 3,
      type: 'highlight',
      videoUrl: '',
      imageUrl: d('data_kov_a_drevo_3/3_1_2_1_S.png'),
      videoEndCorrectUrl: '',
      videoEndWrongUrl: '',
      question: '3. Klikněte na nedostatek Tondova úboru.',
      answers: {},
      correctAnswer: '',
      images: {
        '1': {
          baseImageUrl: d('data_kov_a_drevo_3/svetr.png'),
          hihglightImagerUrl: d('data_kov_a_drevo_3/svetr_high.png'),
          width: 454,
          height: 580,
          scale: 0.52,
          posFromTopinPercent: 30.185,
          posFromLeftinPercent: 50.625,
        },
      },
      correctImage: 1,
      uiLayout: 'top',
      time: 30,
      timeWarning: 10,
      pointsMax: 10,
      pointsSecondAttempt: 5,
      pointsTimePenalty: 3,
    },
    object4: {
      index: 4,
      type: 'highlight',
      videoUrl: '',
      imageUrl: d('data_kov_a_drevo_3/3_1_2_1_S.png'),
      videoEndCorrectUrl: '',
      videoEndWrongUrl: '',
      question: '4. Klikněte na další nedostatek Tondova úboru.',
      answers: {},
      correctAnswer: '',
      images: {
        '1': {
          baseImageUrl: d('data_kov_a_drevo_3/vlasy.png'),
          hihglightImagerUrl: d('data_kov_a_drevo_3/vlasy_high.png'),
          width: 189,
          height: 319,
          scale: 0.51,
          posFromTopinPercent: 12.314,
          posFromLeftinPercent: 57.917,
        },
      },
      correctImage: 1,
      uiLayout: 'top',
      time: 30,
      timeWarning: 10,
      pointsMax: 10,
      pointsSecondAttempt: 5,
      pointsTimePenalty: 3,
    },
  },
}

export const HOTSPOT_DEMO_COURSE = parseCourse(RAW_COURSE)
